import { FC } from 'react';
import { Box } from '@altermaind/web/ui';
import { ProfileCard } from '@/_shared/components/ProfileCard';
import { Employer } from '../../../state/types';

type Props = {
  employer: Employer;
  onEditChange?: (isEditing: boolean) => void;
};

export const TabProfile: FC<Props> = ({ employer, onEditChange }) => {
  return (
    <Box mt='s'>
      <ProfileCard showErrorsProfile hasSettings employer={employer} onEditChange={onEditChange} />
    </Box>
  );
};
